import { apiRequest } from '@/utils/api-request';

export async function deleteArtifact(
  orgId: string,
  artifactId: string,
): Promise<void> {
  const response = await apiRequest({
    url: `/api/v1/orgs/${orgId}/artifacts/${artifactId}`,
    method: 'DELETE',
    target: 'workflow',
  });
  if (response.detail) {
    throw new Error(response.detail);
  }
}
